var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg-404",attrs:{"id":"404"}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('div',{staticClass:"text-md-center"},[_c('div',[_c('v-btn',{staticClass:"btnBack",attrs:{"rounded":""},on:{"click":_vm.goHome}},[_vm._v("Regresar ")])],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }